import { Controller } from '@hotwired/stimulus'

// Approximate Devise's email format (Devise.email_regexp = /\A[^@\s]+@[^@\s]+\z/).
// This is a client-side guard only; the server re-validates every field.
const EMAIL_REGEX = /^[^@\s]+@[^@\s]+$/

export default class extends Controller {
  static targets = ['firstName', 'lastName', 'email', 'terms', 'submit']

  connect() {
    this.validate()
  }

  validate() {
    const isValid =
      this.firstNameTarget.value.trim() !== '' &&
      this.lastNameTarget.value.trim() !== '' &&
      EMAIL_REGEX.test(this.emailTarget.value.trim()) &&
      this.termsTarget.checked

    this.submitTarget.disabled = !isValid
  }
}
